import React from "react";
import {Container} from "@mui/material";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";
import ActiveCuttings from "../timber/components/cutting/CuttingList/ActiveCuttings.tsx";

const ReportsPage = () => {

    useTitle(t`Reports`);
    
    return (
        <Container maxWidth="lg">
            <ActiveCuttings/>
        </Container>
    )
}

export default ReportsPage;
